import React, { useState, useEffect } from "react";
import { Link, useStaticQuery, graphql } from "gatsby";
import _ from "lodash"
import "./PropertyInfo.scss";
import NoImage from "../../../images/no-image.png"
import Contact01 from "../../../images/searchlist/contact-img01.png";

import PropertyList from "../../SearchListing/PropertyInfo/PropertyList";

import { CustomLinks } from "../../common/utils"


const NoPropertyList = (props) => {
    const [department, setDepartment] = useState('');

    useEffect(() => {
        props.department && setDepartment(props.department);
    }, [props.department]);

    const { glstrapi } = useStaticQuery(graphql`
        query NoResultPropertiesStaticQuery {
            glstrapi {
                standardProperties: properties(limit: 25, where: { publish: true, department_in: ["residential", "commercial"] }) {
                    id
                    display_address
                    address
                    search_type
                    status
                    slug
                    title
                    department
                    building
                    price
                    images
                    imagetransforms
                    ggfx_results { id content_type transforms src_import_url src_cftle field }
                    floorarea_min
                    floorarea_max
                    floorarea_type
                    introtext
                    crm_negotiator_id
                    extra
                    latitude
                    longitude
                    auctionDate
                    price_qualifier
                }
                auctionProperties: properties(limit: 25, where: { department_in: ["auction_residential", "auction_commercial"], status_in: ["Unsold", "ReferToAuctioneer"], publish: true }, sort: "auctionDate:desc") {
                    id
                    display_address
                    address
                    search_type
                    status
                    slug
                    title
                    department
                    building
                    price
                    images
                    imagetransforms
                    ggfx_results { id content_type transforms src_import_url src_cftle field }
                    floorarea_min
                    floorarea_max
                    floorarea_type
                    crm_negotiator_id
                    introtext
                    extra
                    latitude
                    longitude
                    auctionDate
                    auctionId
                }
            }
        }
    `)

    const allStandardProps = glstrapi?.standardProperties || [];
    const allAuctionProps = glstrapi?.auctionProperties || [];

    const auction_residential = "auction_residential";
    const auction_commercial = "auction_commercial";
    const isAuction = props.department === auction_residential || props.department === auction_commercial;

    let filterProperties = null;
    if (isAuction) {
        const dept_filtered = props.department2
            ? allAuctionProps.slice(0, 6)
            : allAuctionProps.filter(p => p.department === props.department).slice(0, 6);
        filterProperties = dept_filtered.length >= 2 ? { properties: dept_filtered } : { properties: allAuctionProps.slice(0, 6) };
    } else {
        const status_dept_filtered = allStandardProps.filter(p =>
            (!props.status || p.status === props.status) &&
            (!props.department || p.department === props.department)
        );
        filterProperties = { properties: status_dept_filtered };
    }

    return (
        <React.Fragment>
            {
                filterProperties && filterProperties?.properties?.length > 0 &&
                <>
                    {
                        (props.department === "commercial" || props.department === "residential") ?
                            <p className="results-page-wrapper">We have selected some of our showcase properties for you to browse below. Alternatively, you can search again in the bar above.</p>
                            :
                            <p className="results-page-wrapper">We have selected some of our showcase properties for you to browse below. Alternatively you can register your interest by subscribing to our <Link to={CustomLinks.newsletter_subscription}>auction updates or investments</Link></p>
                    }


                    {
                        filterProperties?.properties?.filter(hit => hit.status !== "Withdrawn").map((hit, index) => {

                            if (index < 6) {

                                // property details url structure
                                let urlStr = ""

                                if (hit.search_type === "sales" && hit.department === 'residential') {
                                    urlStr = `residential-property-for-sale/`
                                } else if (hit.search_type === "lettings" && hit.department === 'residential') {
                                    urlStr = `residential-property-to-rent/`
                                } else if (hit.search_type === "sales" && hit.department === 'commercial') {
                                    urlStr = `commercial-property-for-sale/`
                                } else if (hit.search_type === "lettings" && hit.department === 'commercial') {
                                    urlStr = `commercial-property-to-rent/`
                                } else if (hit.search_type === "sales" && hit.department === 'auction_residential') {
                                    urlStr = `auction-residential-property-for-sale/`
                                } else if (hit.search_type === "sales" && hit.department === 'auction_commercial') {
                                    urlStr = `auction-commercial-property-for-sale/`
                                }
                                // property details url structure

                                var depart_cls = hit.department;
                                if (hit.department === "auction_residential" || hit.department === 'auction_commercial') {
                                    depart_cls = "auction";
                                }

                                return (
                                    <PropertyList
                                        ObjectIDprop={hit.id}
                                        MobImg={hit.images && hit.images.length > 0 ? hit.images[0].url : NoImage}
                                        DeskImg={hit.images && hit.images.length > 0 ? hit.images[0].url : NoImage}
                                        PropertyPrice={hit.price}
                                        Title={hit.title}
                                        Address={hit.display_address}
                                        address_json={hit.address}
                                        Offer={hit.status}
                                        NegoName={hit.crm_negotiator_id}
                                        No={hit.crm_negotiator_id}
                                        Count={hit.images}
                                        ContactImg={Contact01}
                                        searchType={hit.search_type}
                                        propertyDetailsLink={`/${urlStr}${hit.slug}-${hit.id}/`}
                                        OpenMember={props.OpenMember}
                                        Type={"No_Result"}
                                        extra={hit?.extra}
                                        introtext={hit.introtext}
                                        Department={hit.department}
                                        Sub_Area={hit?.subarea}
                                        status={hit.status}
                                        depart_cls={depart_cls}
                                        floorarea_min={hit.floorarea_min}
                                        floorarea_max={hit.floorarea_max}
                                        floorarea_type={hit.floorarea_type}
                                        lotNumber={hit?.extra?.lotNumber}
                                        building={hit.building}
                                        rentPriceMetric={hit?.extra?.rentPriceMetric}
                                        auctionDate={hit?.auctionDate}
                                    />
                                )
                            }
                        })
                    }
                </>
            }
        </React.Fragment>
    )
}

export default NoPropertyList;
